// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"181":"5d29db2d","299":"a825b648"}[chunkId] || chunkId) + "." + {"181":"73a8fc911965a8a1","202":"7ee31d53598541cb","299":"62f33d2868d0093b","651":"60a192374d46ce2e"}[chunkId] + ".js";
};